export const ArrayPattern = 'ArrayPattern';
export const ArrowFunctionExpression = 'ArrowFunctionExpression';
export const FunctionExpression = 'FunctionExpression';
export const Identifier = 'Identifier';
export const Literal = 'Literal';
export const MemberExpression = 'MemberExpression';
export const ObjectExpression = 'ObjectExpression';
export const ObjectPattern = 'ObjectPattern';
export const Property = 'Property';

export const Column = 'Column';
export const Constant = 'Constant';
export const Dictionary = 'Dictionary';
export const Function = 'Function';
export const Parameter = 'Parameter';
export const Op = 'Op';
